// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_D_M","col":"styles_col__DTvXw","actions":"styles_actions__vm_ZJ","conflict":"styles_conflict__KRR1q"};